import { useIntl } from 'react-intl';
import { useCopyToken } from '../../../hooks/useCopyToken';

const CopyTokenButton = () => {
  const intl = useIntl();
  const { copyToken, showSuccess, showError, accessToken, isAccountAllowed } = useCopyToken();

  const isMockToken = accessToken === 'valid-mocked-oauth-bogus-token';

  // Se a conta não está autorizada, não renderiza o botão
  if (!isAccountAllowed) {
    return null;
  }

  return (
    <div className="relative">
      <button
        className="btn btn-default"
        onClick={copyToken}
        title={isMockToken ? intl.formatMessage({ id: "intl-msg:kanban.copyTokenButton.mockTokenActive" }) : intl.formatMessage({ id: "intl-msg:kanban.copyTokenButton.copyAccessToken" })}
      >
        <span className="rioglyph rioglyph-copy !m-[0] mr-1"></span>
        Token
      </button>
      {showSuccess && (
        <div className="absolute top-[-40px] left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-3 py-2 rounded shadow-lg whitespace-nowrap z-50">
          {intl.formatMessage({ id: "intl-msg:kanban.copyTokenButton.copied" })}
        </div>
      )}
      {showError && (
        <div className="absolute top-[-40px] left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-3 py-2 rounded shadow-lg whitespace-nowrap z-50">
          {isMockToken ? intl.formatMessage({ id: "intl-msg:kanban.copyTokenButton.mockTokenError" }) : intl.formatMessage({ id: "intl-msg:kanban.copyTokenButton.copyError" })}
        </div>
      )}
    </div>
  );
};

export default CopyTokenButton;
